var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMoreHorizontal = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 3.5,
    height: 16,
    viewBox: "0 0 3.5 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-948 -190)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.688,
    cy: 1.75,
    rx: 1.688,
    ry: 1.75,
    transform: "translate(951.5 196.312) rotate(90)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.688,
    cy: 1.75,
    rx: 1.688,
    ry: 1.75,
    transform: "translate(951.5 202.624) rotate(90)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.688,
    cy: 1.75,
    rx: 1.688,
    ry: 1.75,
    transform: "translate(951.5 190) rotate(90)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMoreHorizontal);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/more-horizontal.9a98dae7e5e4e3f16032cc316300789b.svg";